import { INVENTORYANDSALES_URL } from "utils/constants";
import { ENDPOINTSINVENTORYANDSALES } from "utils/endpoints";
import { http } from "utils/http";


export const  getMultiSelect =( async (baseURL,url,params={}) =>  await http({
    baseURL,
    url,
    method: 'get',
    params:{
       ...params
    }

}).then((res) => {

    return res.data
}).catch((err) => {

    return Promise.reject( err);
})
)